import { render, staticRenderFns } from "./InstallContract.vue?vue&type=template&id=b84c7246&"
import script from "./InstallContract.vue?vue&type=script&lang=js&"
export * from "./InstallContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports